import { makeStyles } from '@material-ui/styles'
import { withStyles } from '@material-ui/core/styles'
import { MenuItem } from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  iconBordered: {
    display: 'flex',
    backgroundColor: '#F4F6F8',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 40,
    minWidth: 40,
    minHeight: 40,
  },
  action: {
    marginLeft: 'auto',
  },
  menuItem: {
    textTransform: 'none',
  },
}))

export const StyledCheckIcon = withStyles(theme => ({
  root: {
    color: theme.palette.text.secondary,
  },
}))(CheckIcon)

export const StyledMenuItem = withStyles(theme => ({
  root: {
    padding: '0px 8px',
    justifyContent: 'space-between',
  },
}))(MenuItem)

export default useStyles
